import styles from './EmptyLogsAlert.module.scss';

const LEARN_MORE_URL = 'https://kanpai-docs.kanpai.gaai-labs.com/agent_features/logging_and_observability';

export function EmptyLogsAlert() {
  return (
    <div className={ styles.alert } data-testid="empty-logs-alert" role="status">
      <p className={ styles.body }>
        <span className={ styles.heading }>No logs available yet</span>
        <br />
        Logs will appear once your agents or requests start running.
        { ' ' }
        <a
          href={ LEARN_MORE_URL }
          target="_blank"
          rel="noopener noreferrer"
          className={ styles.learnMore }
        >
          Learn More
        </a>
      </p>
    </div>
  );
}
